export default {

    "hero_title_5": "Karaoke video platform by Happy Puppy Group",
    "hero_sub_5": "Starting from Rp 5.000, unlimited karaoke",
    "hero_title_6": "Fun karaoke at home!",
    "hero_sub_6": "Buy RiSing products in 3 easy steps",
    "hero_title_7": "Extend karaoke song access with one click!",
    "hero_sub_7": "Simply select a subscription package and continue karaoke anytime",
    "showcase_3_2_label": "MV & Karaoke Mode",
    "showcase_3_2_desc": "Enjoy karaoke with or without singer vocals",
    "showcase_4_2_label": "Mixer Mode",
    "showcase_4_2_desc": "Pitch up or down up to ± 3 semitones to fit your vocal range",


    "nav_about_us": "About Us",
    "nav_products": "Products",
    "nav_shop": "Shop",
    "nav_news": "News",
    "nav_help": "Help Center",
    "nav_activation": "Device Activation",
    "nav_products_explore": "Explore RiSing Products",
    "nav_products_stb": "RiSing Karaoke Set-Top Box",
    "nav_products_console": "RiSing Karaoke Console One",

    "learn_more_btn": "Learn More",
    "tutor_title": "3 EASY STEPS TO USE RISING",
    "tutor_step_1": "Connect to power",
    "tutor_step_2": "Connect to TV and speaker",
    "tutor_step_3": "Connect to Wi-Fi",
    "advantage_title": "THE ADVANTAGE OF HOME KARAOKE IS EASIER WITH RISING",
    "advantage_f1_title": "Start karaoke in seconds",
    "advantage_f1_desc": "Connect to TV and/or speaker, connect to Wi-Fi, you are ready for karaoke",
    "advantage_f2_title": "Access 80.000+ karaoke songs",
    "advantage_f2_desc": "Find various song choices, starting from regional songs, Indonesian songs, to international songs with various genres",
    "advantage_f3_title": "Control directly from HP",
    "advantage_f3_desc": "Scan QR on TV screen, then use HP to choose songs and control karaoke more practically.",
    "advantage_f4_title": "Only starting from Rp5.000 per day",
    "advantage_f4_desc": "Enjoy unlimited karaoke at home with song access starting from Rp5.000 per day.",
    "退出登录": "Log Out",
    "下载": "Download",
    "点击跳转": "Click to Jump",
    "点击复制": "Click to Copy",
    "账户": "Account",
    "账户小写": "Account",
    "商店": "Shop",
    "商店小写": "Shop",
    "帮助中心": "Help Center",
    "帮助中心小写": "Help center",
    "首页": "Home",
    "订阅": "Subscription",
    "订阅1": "Subscriptions",
    "订阅大写": "SUBSCRIPTION",
    "订阅详情": "Subscription Details",
    "订阅文字": "Manage RiSing service",
    "订单文字": "View order history",
    "计费文字": "View invoices and payments",
    "此字段是必填的": "is required",
    "姓名为必填项": "Name is required",
    "设置文字": "Update profile and users",
    "订单": "Orders",
    "计费": "Billing",
    "设置": "Settings",
    "你好": "Hey, WELCOME BACK!",
    "字幕描述": "Come on, log in/register first to make your future transactions easier!",
    "使用电子邮件链接登录": "Sign in with the email link",
    "使用验证码登录": "Login with OTP code",
    "Email": "Email",
    "继续": "CONTINUE",
    "或者": "Or",
    "其他方式登录": "Another way to Sign in",
    "用手机号": "Continue with Phone Number",
    "用email": "Continue with Email",
    "用谷歌": "Continue with Google",
    "注册账号": "Sign up now and enjoy karaoke at home with RiSing!",
    "还没有Rising账号？": "Don't have a RiSing account yet?",
    "手机号": "Phone Number",
    "注册": "SiGN UP TO START SINGING",
    "注册1": "SiGN UP",
    "其他方式注册": "Another way to Sign up",
    "手机号注册": "Sign up with phone number",
    "谷歌注册": "Sign up with Google",
    "已有账号": "Already have a Rising account",
    "登录": "Log in",
    "注册小写": "Sign up",
    "下一步": "NEXT",
    "第一步": "Step 1 of 3",
    "第一步2": "Step 1 of 2",
    "创建密码": "Create a password",
    "密码": "Password",
    "再次输入密码": "Confirm",
    "此外": "Next",
    "密码已更新": "You can log in now with with your new password",
    "您的密码已成功更新。": "Your password has been successfully updated.",
    "确认新密码": "Confirm",
    "第二步": "Step 2 of 3",
    "第二步2": "Step 2 of 2",
    "关于自己": "Please tell us about you",
    "生日": "Date of birth",
    "性别": "Gender",
    "入门套装": "VIEW DETAILED PACKAGE",
    "查看产品详情": "VIEW PRODUCT DETAIL",
    "取消": "Cancel",
    "保存": "Save",
    "产品尺寸": "Product dimension",
    "包装尺寸": "Package dimension",
    "包裹重量": "Package weight",
    "加入购物车": "ADD TO CART",
    "商品已添加到购物车": "Item added to cart",
    "商品已从购物车中移除": "Item removed from cart",
    "自动续订": "Auto Renewal",
    "安装指南": "INSTALATION GUIDE",
    "您的购物车里什么都没有。前往商店订购商品。": "There is nothing in your cart. Go to shop to order an item.",
    "去商店": "Go to Shop",
    "结账": "CHECK OUT",
    "每月定期付款": "Recurring Monthly Payment",
    "一次性付款": "One Time Payment",
    "税费": "Tax",
    "保险费": "Insurance Fee",
    "运费": "Shipping Fee",
    "自动-续费": "Auto-Renewal",
    "免费": "Free",
    "今日应付总额": "Total Due Today",
    "点击“下订单”，即表示我同意": "By clicking \"Place Order\", I agree to the ",
    "服务条款和隐私政策": "Terms of Service and Privacy Policy",
    "下单": "Place Order",
    "鉴权失败": "Authentication failed",
    "恭喜！支付成功": "Congratulations ! Payment Successful",
    "抱歉，支付失败": "Sorry, Payment failed",
    "付款时间": "Payment Time",
    "查看订单": "View Order",
    "收货地址": "Shipping Address",
    "改变": "Change",
    "邮箱": "Email",
    "邮政编码": "Postal Code",
    "送货地址第一行": "Shipping Address Line 1",
    "送货地址第二行": "Shipping Address Line 2 ",
    "可选，例如:公寓/楼栋": "optional E.G apart. / building",
    "城市": "City",
    "州/省": "Province",
    "国家": "Country",
    "必需的": "required",
    "应用配送地址": "Apply Shipping Address",
    "支付信息": "Payment Information",
    "名字": "Name",
    "如卡片上所示": "as it appears on card",
    "纳税人识别号/身份证号码/税务ID": "NPWP / NIK / Tax ID",
    "电子钱包1": "eWallet",
    "卡号": "Card Number",
    "安全码": "Security Code",
    "月/年": "Month/Year",
    "账单邮编/邮政编码": "Billing Zip / Postal Code",
    "格式无效": "Invalid format",
    "是必需的，格式无效": " is required,Invalid format",
    "设为默认支付方式": "Use as Default Payment Method",
    "订单大写": "ORDERS",
    "按订单号搜索": "Search by order number",
    "下单时间": "Placed",
    "状态": "Status",
    "商品": "Items",
    "订单号": "Order Number",
    "快递单号": "Tracking Number",
    "预计送达时间": "Estimated Delivery",
    "订单摘要": "Order Summary",
    "订单处理后无法更改收货地址。请在订单发货后通过追踪链接联系承运商进行调整": "You cannot change shipping address once the order has been processed. Please contact the carrier from your tracking link once the order has shipped to make adjustments.",
    "订单详情": "Order Detail",
    "取消订单": "Cancel",
    "支付1": "Pay",
    "支付摘要": "Payment Summary",
    "商品小计": "Item Subtotal",
    "订单总额": "Order Total",
    "关于更新订单的问题？请查看我们的": "Questions about updating your order? See our ",
    "常见问题解答": "FAQ.",
    "男": "Male",
    "女": "Female",
    "不想透露": "Prefer not to say",
    "第三步": "Step 3 of 3",
    "邮箱链接": "E-mail verification",
    "验证手机号码": "Phone number verification",
    "发送链接邮箱1": "We've sent a link verification email to {email}. Link will expire in 24 hours. If you can't find it in your inbox, please check your Junk/Spam folder.",
    "发送链接邮箱2": "If you still haven't received the verification email, click the Resend Email button below.",
    "重试邮件": "RESEND VERIFICATION EMAIL",
    "邮箱注册": "Sign up with Email address",
    "60s": "The code will expire in 60s",
    "重试": "Resend Code",
    "用密码登录": "Log in with a password",
    "id": "RISING ID",
    "mac地址": "MAC",
    "软件版本": "Software Version",
    "最后更新": "Last Software Update",
    "服务位置": "Service Location",
    "总点击次数": "Total Hit Counts",
    "昵称": "Nickname",
    "服务计划": "Service Plan",
    "解绑订阅": "Unbind Device",
    "个人资料": "Profile",
    "通知偏好": "Notification Preference",
    "修改资料": "Edit Profile",
    "电话": "Phone Number",
    "绑定mac": "Bind MAC",
    "关联账户": "Connect to Account",
    "修改名字": "Edit Nickname",
    "未激活": "Inactive",
    "激活": "Active",
    "管理": "Manage",
    "修改": "Edit",
    "管理服务计划": "Manage Service Plan",
    "产权激活": "Activate Your RiSing Device",
    "字幕启用": "Enter the MAC address printed on your RiSing product box to activate the device or manage your subscription.",
    "Mac输入": "MAC Address",
    "STB激活": "Device Activation",
    "输入MAC": "Enter the character MAC address exactly as printed on your box.", 
    "Mac输入占位符": "Input MAC Address",
    "正在寻找一台Mac": "Search MAC Address",
    "不接收消息": "Didn't receive the message? Resend",
    "未收到验证码": "Didn't receive the code? Resend Code",
    "未收到验证码2": "Didn't receive the code?",
    "连接": "Connect",
    "重新发送验证码3": "Resend Code",
    "订阅时长": "Subscription Duration",
    "请先选择订阅时长": "Please select a subscription duration first",
    "选择您的订阅时长": "Select your subscription duration",
    "PERBARUI LANGGANAN": "RENEW SUBSCRIPTION",
    "未找到MAC地址": "We couldn't find the MAC Address you entered. Please check the number printed on your RiSing product and try again.",
    "注册设备": "Register Your Device",
    "注册字幕设备":"This device is not yet connected to an account. Add profile details to activate it.",
    "地址": "Shipping Address",
    "支付": "Payment",
    "支付方式": "Payment Method",
    "修改信息": "Edit Profile",
    "取消自动续费": "Cancel Auto Renewal",
    "改变计划": "Change Plan",
    "您确定要更改计划吗": " Are you sure you want to change plans ?",
    "您确定要启用自动续订吗": " Are you sure you want to enable auto renewal ?",
    "确认取消自动续费吗,取消后，将在下个月停止自动续费": " Are you sure to cancel the automatic renewal? After cancellation, automatic renewal will stop next month",
    "您确定要取消自动续订功能吗": "Are you sure you want to cancel auto-renewal ?",
    "取消后，自动续订功能将停止，您的会员资格将于失效": "After cancellation, auto-renewal will stop, and your membership will expire on",
    "服务将于更改": "Service will change on",
    "您将被收取的费用": "and you will be billed IDR",
    "今天": "today.",
    "您的新月度服务价格为": "Your new monthly service price is",
    "并将于开票": "and willbe billed on",
    "提交": "Continue",
    "选择确认即表示您承认并同意适用的条款和条件": "By selecting Confirm, you acknowledge and agree to ",
    "启用自动续订": "Enable auto-renewal to continue your monthly streaming subscription at ",
    "订阅月": "per month. ",
    "您想激活它吗": "Would you like to activate it",
    "您的服务计划": "Yours Service Plans",
    "可用服务计划": "Available Service plans",
    "自动续费": "Auto Renewal",
    "!自动续费": "No Auto Renewal",
    "请输入密码": "password is required",
    "请再次输入密码": "confirm password is required",
    "两次输入密码不一致!": "Passwords do not match. Please re-enter",
    "密码校验": "At least 8 digits alphanumeric, including 1 capital and 1special character",
    "身份证": "ID Number",
    "邮编": "Zip/Postal Code",
    "计费大写": "BILLING",
    "管理您的发票和付款": "Manage your invoices and payments",
    "发票": "Invoices",
    "按发票号码搜索": "Search by invoice number",
    "日期": "Date",
    "备注": "Description",
    "发票号码": "Invoice Number",
    "方法": "Method",
    "总计": "Total",
    "市区": "Province",
    "具体地址1": "Shipping Address Line 1",
    "具体地址2": "Shipping Address Line 2",
    "名": "First Name",
    "姓名2": "Full Name",
    "名银行": "First Name(as it appears on card)",
    "姓银行": "Last Name(as it appears on card)",
    "姓": "Last Name",
    "复制成功": "Copy successful",
    "在家唱卡拉OK": "KARAOKE AT HOME,",
    "暂时": "FOR MORE",
    "哪个更令人兴奋": "EXCITING MOMENTS",
    "卡拉": "KARAOKE",
    "一起": "TOGETHER",
    "在家": "AT HOME",
    "任何地点": "ANYWHERE",
    "在我们的应用程序中查找您最喜欢的歌曲": "find your favorite songs in our app",
    "家庭卡拉OK娱乐，每天仅需5000印尼盾": "Home Karaoke Entertainment only Rp. 5,000 per day",
    "现在开始唱歌": "Start Singing Now",
    "免费唱歌一个月": "Sing for Free for a Month",
    "联系我们": "Contact Us",
    "我们的位置": "Our Location",
    "特征": "Feature",
   "下载应用程序": "Download the Rising App",
    "找到我们": "Find Us",
    "跟着我们": "Follow Us",
    "VISITHAPPY": "RiSing © 2026 RiSing is part of the Happy Puppy Group. Visit us at ",
    "使用密码登录": "Log in with a password",
    "点击链接登录": "Log in without a password",
    "信用卡": "Debit / Credit Card",
    "每一刻都闪耀着光芒": "and every moment shines",
    "一起在音乐中": "together in music",
    "从麦克风到魔术，每个声音都有自己的位置": "From mic to magic, every voice finds its place,",
    "拿起麦克风，像明星一样歌唱吧": "Grab the mic, and sing like a star!",
    "尽情享受卡拉OK吧": "ENJOY KARAOKE AS MUCH AS YOU WANT",
    "向世界展示自己": "Show yourself to the world",
    "通过你唱的歌": "through the songs you sing",
    "选择你喜欢的流派并创作": "Choose the genres you like and create",
    "播放列表，显示你的共鸣": "playlist that shows your vibes.",
    "每一个相聚的瞬间，": "EVERY MOMENT OF TOGETHERNESS,",
    "卡拉OK更有趣": "MORE FUN WITH KARAOKE",
    "你最喜欢的": "YOUR FAVORITE",
    "歌在这里等着你": "SONG IS WAITING HERE",

    "享受音乐的新方式": "A NEW WAY TO ENJOY MUSIC",
    "享受音乐的新方式2": "A NEW WAY TO ENJOY KARAOKE AT HOME",
    "在家唱卡拉OK": "KARAOKE AT HOME",
    "客户评价": "WHAT OUR CUSTOMERS SAY",
    "ENTERTAINMENTKARAOKE": "All-in-One Home Karaoke Entertainment​",
    "ENTERTAINMENTKARAOKE2": "All-in-One Home Entertainment Karaoke by Happy Puppy Group​​",
    "ENTERTAINMENTKARAOKESUB": "Exciting and Unlimited Karaoke at Home",
    "RISINGSTB" : "RiSing KARAOKE SET-TOP BOX",
    "RISINGSTBSUB" : "A portable karaoke device containing 80,000+ karaoke songs by Happy Puppy",
    "RISINGCONSOLE" : "RiSing CONSOLE ONE",
    "RISINGCONSOLESUB" : "Powerful speaker with built-in karaoke and wireless microphone",
     "大家起唱卡拉OK更有趣" : "KARAOKE IS MORE FUN TOGETHER",
    "大家起唱卡拉OK更有趣SUB" : "Sing along with family, friends, or coworkers anytime and anywhere",


    "就是用你的声音让它变得生动起来": "is to make it come alive with your voice",
    "与我们一起度过难忘的歌唱体验": "MEMORABLE SINGING EXPERIENCE WITH US ",
    "做好充分准备": "GET READY FOR THE MOST",
    "随时随地享受娱乐": "ENJOY ENTERTAINMENT ANYTIME,",
    "不离开家": "WITHOUT LEAVING THE HOUSE",
    "本月订阅优惠尽享最优": "get the best deals on this month’s subscriptions",
    "每月": "Monthly",
    "入门包": "Starter Pack",
    "RISING Player（家用卡拉OK设备）": "RiSing Player (Home Karaoke Equipment)",
    "免费试用 30 天": "The karaoke subscription is valid for 30 days and comes with an additional 60 days as a bonus!",
    "月": "month",
    "季度": "Quarterly",
    "条款和条件": "Terms & Conditions",
    "下个月的订阅费为每月 150,000 印尼盾。": "Subscription fee of IDR 150,000 per month for the following month",
    "隐私政策": "Privacy Policy",
    "自信的表达": "CONFIDENT EXPRESSION",
    "就在家": "JUST FROM HOME",
    "尽情歌唱": "SING YOUR HEART OUT",
    "大声唱吧": "SING IT LOOOOUD",
    "税号": "NPWP / NIK / Card ID",
    "增加": "Add",
    "删除": "Delete",
    "戴上它，开始唱歌吧": "JUST PUT IT ON & START SINGING",
    "安装简便，仅需1分钟": "EASY INSTALLATION ONLY 1 MINUTE",
    "收录超过 80,000 首最新歌曲": "COLLECTION OF 80,000+ MOST UPDATED SONGS",
    "本地及国际歌单": "LOCAL & INTERNATIONAL PLAYLISTS",
    "电子钱包": "E-wallet",
    "修改邮箱": "Change email",
    "修改手机号": "Change phone number",
    "确认邮箱": "Confirm email",
    "确认手机号": "Confirm phone number",
    "绑定成功": "Binding successful",
    "通知首选项": "Notification Preferences",
    "选择要接收的通知": "Choose which notifications you would like to receive. You may still receive notificationsafter opting out",
    "营销": "Marketing",
    "感兴趣的新闻": "RiSing news and updates that you may be interested in",
    "订阅发票": "Subscription and order invoices, payment confirmations, and other billing notifications",
    "订单运输": "Orders and shipping",
    "发货通知": "Receive notifications when orders are placed, when they ship, and when they’re changed",
    "支持": "Support",
    "新活动通知": "Receive notifications for new activity on support messages",
    "SMS": "SMS",
    "支持中心": "Support Center",
    "我们能帮你什么": "WHAT CAN WE HELP YOU with?",
    "回首页": "Home",
    "让我们知道这是否有帮助": "Let us know if this helped",
    "是": "Yes",
    "否": "No",
    "邮箱必填": "Email address is required",
    "手机号必填": "Phone number is required",
    "必须勾选": "By registering, I agree to RiSing's ",
    "服务条款": " Terms of Service ",
    "隐私协议": " Privacy Policy ",
    "和": "and",
    "请输入正确的格式": "Invalid email format. Please enter a valid email",
    "请输入首名字": "First name is required",
    "请输入尾名字": "Last name is required",
    "请勾选服务条款": "Please read and check the Privacy Policy and Terms of Service to proceed.",
    "保存成功": "Saved successfully",
    "预览": "preview",
    "请输入地址": "Please enter the address",
    "请输入邮编": "Please enter postal code",
    "请输入邮箱": "Please enter email address",
    "请输入手机号": "Please enter your phone number",
    "请输入证件号码及上传证件图片": "Please enter certificate",
    "使用默认支付方式": "Use as Defualt Payment Menthod",
    "提示": "Tips",
    "确认是否删除": "Are you sure to delete this payment method? Auto-renewals may fail if active",
    "请先完善个人信息": "Please complete your personal information first",
    "修改成功": "Modified successfully",
    "请前往个人中心保存手机号": "Please go to Personal Center to save your phone number",
    "请前往个人中心保存邮箱": "Please go to Personal Center to save your email",
    "邮箱勾选提示": "You'll get emails about {category} moving forward.",
    "短信勾选提示": "You'll get SMS about {category} moving forward.",
    "邮箱取消提示": "You'll no longer get emails about {category}.",
    "短信取消提示": "You'll no longer get SMS about {category}.",
    "添加支付方式": "Add Payment Method",
    "主动计划": "Active plan",
    "订阅计划链接跳转": "Terms of Service",
    "暂无数据": "No data available",
    "请选择": "Please select",
    "请修改您的头像": "Please modify your profile picture",
    "请选择服务计划": "Please select a service plan",
    "30天活跃订阅": "30 Days Active Subscription",
    "90天活跃订阅": "90 Days Active Subscription",
    "访问80000多首卡拉OK歌曲": "Access to 80,000+ Karaoke Songs.",
    "无广告歌唱不受干扰": "Ad Free, Sing without distraction.",
    "随时取消": "Cancel anytime.",
    "银行虚拟账户": "Virtual Account",
    "二维码支付": "QRIS",
    "零售": "Retail",
    "银行虚拟账户付款": "Virtual Account Payment",
    "总付款": "Total Payment",
    "在...内支付": "Pay Within",
    "虚拟账户": "Virtual Account",
    "截止日期": "Due on",
    "请选择支付方式": "Please select a payment method",
    "正在确认支付结果": "Confirming payment result",
    "零售支付": "Retail Payment",
    "电子钱包支付": "E-Wallet Payment",
    "继续通过手机进行支付": "Continue your payment on mobile phone",
    "二维码支付2": "QRIS Payment",
    "支付代码": "Payment  Code",
    "已逾期": "Overdue",
    "支付状态": "Payment Status",
    "账单信息异常": "Bill information is abnormal",
    "支付成功": "Payment Successful",
    "支付失败": "Payment Failed",
    "请重新尝试支付" : "Please try the payment again.",
    "支付超时": "Payment Timeout",
    "付款已取消": "Payment Cancelled",
    "付款取消说明": "Payment cancelled and order not processed yet. Please reorder or contact admin for assistance.",
    "付款链接已过期。": "The payment link has expired. Please create a new order to continue payment by contacting the admin.",
    "付款成功": "Congratulations on your successful payment",
    "付款成功详情": "Your RiSing subscription is now active. Enjoy all karaoke features and an unlimited singing experience.",
    "详情": "Detail",
    "支付详情": "Payment Detail",
    "时": "Hours",
    "分": "Minutes",
    "秒": "Seconds",
    "取消账单": "Cancel Billing",
    "确认取消该账单？": "Are you sure you want to cancel this bill?",
    "正在处理": "Processing",
    "取消成功": "Cancelled successfully",
    "取消失败": "Cancellation failed",
    "忘记密码": "Forgot password?",
    "发送重置链接": "Send Reset Link",
    "创建账号": "Create new account",
    "返回登录": "Return to Login",
    "链接已发送": "WE GOT YOU",
    "订阅历史": "Subscription History",
    "订阅编号": "Subscription Number",
    "订阅计划名称": "service plan",
    "查看订阅历史": "View Subscription History",
    "不续费": "No Auto Renewal",
    "退款政策": "Terms & Condition",
    "正在处理支付": "Processing Payment",
    "区域": "District",
    "街道": "Subdistrict",
    "默认": "Default",
    "请选择district": "Please select district",
    "请选择subdistrict": "Please select subdistrict",
    "选择信用卡": "Select Credit Card",
    "新增信用卡": "Add a new card",
    "新增信用卡并支付": "Add New Card",
    "只有支付1": "Add New Card",
    "只有支付2": "Add New Card",
    "鉴权失败，请重试": "Authentication failed, please try again",
    "支付方式添加成功": "Payment method added successfully",
    "添加新卡并订阅": "Add a new card and subscribe",
    "下载失败，请稍后重试": "Download failed, please try again later",
    "PDF 下载成功": "PDF downloaded successfully",
    "PDF 文件不存在": "PDF file does not exist",
    "家庭使用": "for home, personal, and non-commercial purpose",
    "忘记密码手机": "Forgot Password?",
    "请先输入手机号": "Please enter your phone number first.",
    "手机号未注册": "This Phone number is not registered. Please sign up.",
    "验证码说明": "Enter the 6-digit code sent to you at {phone}",
    "请输入我们发送到您手机号码的6位验证码。": "Enter the 6-digit code that we have sent to your mobile number.",
    "重新发送验证码": "RESEND CODE",
    "重新发送验证码2": "RESEND OTP CODE",
    "继续重置": "continue to reset",
    "验证码错误": "Invalid verification code. Please check and try again.",
    "验证码已过期": "This verification code has expired. Please resend the code.",
    "新密码": "New Password",
    "密码格式无效": "At least 8 digits alphanumeric, including 1 capital and 1special character",
    "两次密码不一致": "Passwords do not match. Please re-enter.",
    "新密码不能与旧密码相同": "New password cannot be the same as the old password.",
    "密码更新完成": "Password Updated complete!",
    "创建新密码": "Create new password",
    "订阅类型": "Auto Renewal",
    "发送链接邮箱3": "We've sent you a password reset link to {email}.Tap on the link to reset your password.",
    "已向以下邮箱发送验证邮件：": "A verification email has been sent to {email}.",
    "确定": "OK",
    "确认": "Confirm",
    "账户删除正在进行中": "Account Deletion in Progress",
    "取消删除账户": "Cancel Delete Account",
    "删除账户": "Delete Account",
    "确认删除账户": "Confirm Account Deletion",
    "若继续，则表示您请求删除您的账户": "By proceeding, you are requesting to delete your account",
    "特此通知": "Please be informed that",
    "您可在提交后7天内取消此请求": "You may cancel this request within 7 days of submission",
    "在7天的待处理期间，您的账户将保持活跃状态": "Your account will remain active during the 7-day pending period",
    "您的账户状态将显示正在进行删除操作": "Your account status will indicate that deletion is in progress",
    "一旦永久删除，您的注册邮箱地址或电话号码可能会在14天后被用于创建新账户": "Once permanently deleted, your registered email address or phone number may be used to create a new account after 14 days",
    "7天期限过后，此操作将不可撤销": "After the 7-day period has passed, this action is irreversible",
    "删除请求已提交": "Deletion Request Submitted",
    "您的账户删除请求已成功提交": "Your account deletion request has been successfully submitted",
    "您的账户将在接下来的7天内保持活跃状态。在此期间": "Your account will remain active for the next 7 days. During this period",
    "您可以随时取消删除请求": "You may cancel the deletion request at any time.",
    "您的账户将显示一则通知，表明正在进行删除操作": "Your account will display a notice indicating that deletion is in progress.",
    "如果请求在7天内未被取消，您的账户将被永久删除": "If the request is not cancelled within 7 days, your account will be permanently deleted",
    "永久删除后": "After permanent deletion",
    "14天后，您可以使用您的电子邮件地址或电话号码重新注册": "your email address or phone number can be used to register again after 14 days",
    "确认取消账户删除": "Confirm Cancel Deletion Account",
    "通过处理，您请求取消/删除您的账户": "By processing you are requesting to cancel  delete your account",
    "成功取消账户删除": "Success Cancel Deletion Account",
    "账户删除取消已成功": "Account deletion cancellation has been successful",
    "享受使用RiSing的乐趣": "Enjoy using RiSing",
    "在账户删除冷静期内，无法进行支付": "Payment unavailable during account deletion cooling-off period.",
    "印度尼西亚排名第一的家庭娱乐卡拉OK": "#1 HOME-ENTERTAIMENT KARAOKE IN INDONESIA",
    "在家唱歌，也能成为明星": "Sing from home and become a star",
    "开始唱歌": "Start Singing",
    "快乐小狗集团旗下成员": "Part of the Happy Puppy Group",
    "获得官方音乐授权支持": "Supported by official music licensing through",
    "RISING 以全新方式呈现": "RiSing PRESENTS IN A NEW WAY",
    "在家享受卡拉OK": "ENJOY KARAOKE FROM HOME",
    "RiSing 拥有全面合法的歌曲库，为任何人提供了一个表达自我、释放情感、与亲近之人一起享受歌唱乐趣的空间。": "With a comprehensive and legal song catalog, RiSing provides a space for anyone to express themselves, release their emotions, and enjoy singing with those closest to them.",
    "在家卡拉OK所需的一切": "EVERYTHING YOU NEED FOR HOME KARAOKE",
    "功能滑块1": "Start karaoke in just seconds",
    "功能滑块2": "Access 80,000+ karaoke songs, with more added regularly",
    "功能滑块3": "Choose how you karaoke, with or without the singer's vocals",
    "功能滑块4": "Enjoy unlimited karaoke for just Rp 5,000 per day",
    "试用3个月，费用为999,000印尼盾": "Try 3 months for Rp999,000",
    "查看所有计划": "View all plans",
    "特别新手包售价 999,000 印尼盾，包含 Rising Player 和 3 个月的订阅服务。": "Special Starter Pack Rp. 999,000 gets RiSing Player and a 3-month subscription, then",
    "此后每月150,000印尼盾。": "RRp. 150,000 per month thereafter.",
    "播放列表": "Playlist",
    "播放列表描述": "Easily find your favorite songs and create your own playlist",
    "新歌": "New Song",
    "新歌描述": "Discover newly added songs",
    "历史": "History",
    "历史描述": "Explore the songs that are currently popular",
    "热门点击": "Top Hits",
    "热门点击描述": "See the most frequently sung and currently popular songs",
    "流派": "Genre",
    "流派描述": "Find songs based on your favorite genre",
    "玩家": "Player",
    "玩家描述": "Set and enjoy the song you are singing",
    "队列": "Queue",
    "队列描述": "Add the next song to your singing queue list",
    "因为卡拉OK和大家一起更有趣": "BECAUSE KARAOKE IS ALWAYS MORE FUN TOGETHER",
    "家庭卡拉OK": "Family Karaoke",
    "与朋友同乐": "With Friends",
    "下班后聚会": "After Office",
    "独自的": "Alone",
    "准备好在家卡拉OK了吗？": "READY TO KARAOKE AT HOME?",
    "RiSing让卡拉OK变得更简单、方便、实惠。": "RiSing makes karaoke easier, more practical, and affordable.",
    "RiSing新手套装RTX3M206SPH（家庭、个人及非商业用途）": "RiSing STARTER PACK RTX3M206 SPH (FOR HOME, PERSONAL, AND NON-COMMERCIAL USE)",
    "售价999000印尼盾": "Rp999.000",
    "原价1250000印尼盾": "Rp 1.300.000",
    "折扣17%": "17%",
    "RiSing播放器（家用卡拉OK设备）": "RiSing Karaoke Set-Top Box (Home Karaoke Device)",
    "订阅卡拉OK30天+免费额外60天！": "90 days free singing",
    "访问80000首以上卡拉OK歌曲": "Access 80,000+ Karaoke Songs.",
    "无广告，畅唱无阻": "No Ads. Sing Without Interruption.",
    "随时可取消": "Cancel anytime.",
    "立即开始唱歌": "Start Singing Now",
    "次月起每月订阅费用150000印尼盾": "Rp150,000 per month subscription fee for the following month",
    "关于我们": "About Us",
    "买": "Buy",
    "行动": "Action",
    "英雄标语": "SING AND SHINE FROM HOME",
    "关于我们标题": "AT RiSing,<br>WE BELIEVE SINGING IS A FORM OF SELF-EXPRESSION.",
    "关于我们段落一": "Built on Happy Puppy's legacy of bringing family karaoke across Indonesia, RiSing takes karaoke into a new era — from public spaces to private ones, from physical to digital, and from static to on-demand.",
    "关于我们段落二": "Now, anyone can sing, express themselves, and enjoy the joy of karaoke anytime at home.",
    "关于我们徽章文字": "With a licensed song catalog that supports local musicians, in collaboration with ASIRINDO (Indonesian Recording Industry Association)",
    "精彩时刻标题": "MOMENTS TO FREE YOUR VOICE",
    "时刻说明一": "When the family gets together and the favorite songs start playing.",
    "时刻说明二": "When celebrating a birthday with the closest people.",
    "时刻说明三": "When friends sing along without shame.",
    "时刻说明四": "When you relax after a long day at work.",
    "第五矩的描述": "When nostalgia arises from an old song that suddenly plays.",
    "第六时刻的描述": "When home feels like a private karaoke room.",
    "旅程标题": "BIG STEPS IN<br>OUR JOURNEY",
    "里程碑2026": "RiSing is here, bringing karaoke to your home and opening a new era of singing.",
    "里程碑2022": "Happy Puppy has grown to more than 73 outlets in 46 cities in Indonesia.",
    "里程碑2004": "MURI named Happy Puppy as the first family karaoke in Indonesia.",
    "里程碑1992": "Happy Puppy introduces the concept of family karaoke in Indonesia.",
    "STB图片描述": "RiSing STB",
    "STB右侧图片描述": "Anyone Can Be a Star",
    "购物车标题": "CHECKOUT",
    "返回": "Back",
    "更改": "Change",
    "手机号码": "Phone No.",
    "手机号码错误提示": "Phone number is required and format is invalid",
    "电子邮件": "Email",
    "电子邮件错误提示": "Email is required and format is invalid",
    "邮政编码错误提示": "Postal code is required",
    "省份": "Province",
    "区县": "District",
    "区县错误提示": "District is required",
    "村庄": "Sub-district",
    "村庄错误提示": "Sub-district is required",
    "地址行1": "Address Line 1",
    "地址错误提示": "Address is required",
    "地址行2": "Address Line 2",
    "可选": "optional",
    "保存地址": "Save Address",
    "订单标签": "ORDER",
    "损坏保护": "Damage Protection",
    "配送选项": "Shipping Options",
    "快递类型常规": "Regular",
    "预计到达": "Estimated Arrival",
    "天": "Days",
    "付款信息": "Payment Information",
    "信用借记卡": "Credit / Debit Card",
    "信用卡提示": "Credit card details will appear after \"Place Order\".",
    "总价格": "Total Price",
    "产品": "Product",
    "总损坏保护": "Total Damage Protection",
    "服务费": "Service Fee",
    "创建订单": "Place Order",
    "同意条款说明": "By pressing \"Place Order\", you agree to the terms & conditions and privacy policy.",
    "购物车为空": "Your shopping cart is empty.",
    "付款状态": "Payment Status",
    "付款倒计时": "Pay Within",
    "已过期": "Expired",
    "截止时间": "Deadline",
    "电子钱包提示": "Continue payment via the app on your phone.",
    "付款码": "Payment Code",
    "虚拟账户号码": "Virtual Account Number",
    "QRIS付款": "QRIS Payment",
    "二维码": "QR Code",
    "信用卡付款": "Credit Card Payment",
    "添加新卡并付款": "Add New Card & Pay",
    "用新卡付款": "Pay with New Card",
    "设为默认付款方式": "Set as default payment method",
    "付款": "Pay",
    "电子钱包付款": "E-Wallet Payment",
    "零售付款": "Retail Payment",
    "虚拟账户付款": "Virtual Account Payment",
    "自提门店": "Pickup at Outlet",
    "自提说明": "Pick up directly at our store",
    "门店名称": "Main Outlet - South Jakarta",
    "门店地址": "Jl. Sudirman No. 123, Kebayoran Baru, South Jakarta 12190",
    "营业时间": "Mon – Sat: 09.00 – 18.00 WIB",
    "自提节省说明": "You save on shipping & insurance by picking up at the outlet!",
    "新闻": "News",
    "回到新闻": "Back to the news",
    "经过": "By",
    "最新文章": "RECENT POST",
    "了解更多": "Learn More",
    "暂无文章": "No news for this category yet.",
    "其他文章": "Explore More News",
    "查看全部": "View All",
    "收起": "View Less",
    "搜索": "Search Your Favorite News",
    "全部": "All",
    "活动": "Event",
    "故事": "Stories",
    "文章一标题": "Now Playing: RiSing",
    "文章一描述": "Still can't move on from RiSing's Press Conference! Stay tuned for the official launch of RiSing on March 25, 2026! ✨",
    "文章二标题": "RiSing Giveaway",
    "文章二描述": "Counting down! RiSing is coming to your home soon ✨",
    "文章三标题": "Lorem Ipsum Skavazio",
    "文章三描述": "Lorem Ipsum Skavazio",
    "验证失败": "Verification Failed!",
    "链接无效或已过期。": "The link is invalid or has expired.",
    "链接失效": "Oops! This Reset link has expired.",
    "优惠券": "VOUCHER",
    "使用促销代码": "Use voucher code",
    "促销代码": "Voucher Code",
    "输入促销代码": "Enter Voucher Code",
    "例如：RIS134": "Example : RIS134",
    "申请促销": "Apply Voucher",
    "必须填写促销代码": "Voucher code must be filled in",
    "已应用促销代码": "Voucher code applied successfully",
    "您输入的优惠码不正确": "The voucher code you entered is invalid",
    "促销代码验证失败": "Failed to verify voucher code. Please try again.",
    "促销代码已取消": "Voucher code has been removed",
    "使用": "Use",
    "直到": "Until",
    "家": "Home",
    "店铺": "Shop",
    "链接设备": "Bind Device",
    "之前付款": "pay before",
    "扫描二维码": "Scan QR Code",
    "下载二维码": "Download QR Code",
    "账单总额": "Total Bill",
    "返回首页": "Return to Home",
    "立即支付": "Pay Now",
    "检查付款状态": "Check Payment Status",
    "支付说明": "Payment Instructions",
    "打开您的电子钱包或手机银行应用": "Open your e-wallet or mobile banking app",
    "选择扫码 / QRIS 菜单": "Select Scan QR / QRIS menu",
    "扫描上方二维码": "Scan the QR Code above",
    "检查付款详情并确认": "Check the payment details and confirm",
    "支付完成": "Payment completed",
    "ATM BCA": "ATM BCA",
    "ATM BCA 步骤1": "Insert your BCA ATM card & PIN.",
    "ATM BCA 步骤2": "Select Other Transactions → Transfer.",
    "ATM BCA 步骤3": "Select to BCA Virtual Account.",
    "ATM BCA 步骤4": "Enter the Virtual Account number shown.",
    "ATM BCA 步骤5": "Make sure the name & bill amount are correct, then confirm.",
    "ATM BCA 步骤6": "Transaction complete, save your payment receipt.",
    "m-BCA (BCA Mobile)": "m-BCA (BCA Mobile)",
    "m-BCA 步骤1": "Login to m-BCA with your access code.",
    "m-BCA 步骤2": "Select m-Transfer → BCA Virtual Account.",
    "m-BCA 步骤3": "Enter the Virtual Account number.",
    "m-BCA 步骤4": "Check the payment information, then press OK.",
    "m-BCA 步骤5": "Enter your m-BCA PIN to confirm.",
    "m-BCA 步骤6": "Transaction successful, check your notification.",
    "网银BCA": "Internet Banking BCA",
    "网银BCA 步骤1": "Login to klikbca.com.",
    "网银BCA 步骤2": "Select Transfer Funds → Transfer to BCA Virtual Account.",
    "网银BCA 步骤3": "Enter the Virtual Account number.",
    "网银BCA 步骤4": "Check the details & amount, then click Continue.",
    "网银BCA 步骤5": "Enter your KeyBCA response for authorization.",
    "网银BCA 步骤6": "Payment successful.",
    "ATM bjb": "ATM bjb",
    "ATM bjb 步骤1": "Insert your bjb ATM card & PIN.",
    "ATM bjb 步骤2": "Select Transaction → Payment → Others.",
    "ATM bjb 步骤3": "Select Virtual Account.",
    "ATM bjb 步骤4": "Enter the Virtual Account number.",
    "ATM bjb 步骤5": "Confirm the name & amount, then press OK.",
    "手机银行bjb DIGI": "Mobile Banking bjb DIGI",
    "手机银行bjb DIGI 步骤1": "Login to bjb DIGI.",
    "手机银行bjb DIGI 步骤2": "Select Payment → Virtual Account.",
    "手机银行bjb DIGI 步骤3": "Enter the Virtual Account number.",
    "手机银行bjb DIGI 步骤4": "Check the details, enter your PIN, and confirm.",
    "网银bjb": "Internet Banking bjb",
    "网银bjb 步骤1": "Login to ib.bankbjb.co.id.",
    "网银bjb 步骤2": "Select Payment → Virtual Account.",
    "网银bjb 步骤3": "Enter the Virtual Account number.",
    "网银bjb 步骤4": "Confirm with token/OTP.",
    "NEO+应用 (BNC)": "NEO+ App (BNC)",
    "NEO+ 步骤1": "Login to the NEO+ app.",
    "NEO+ 步骤2": "Select Transfer → Virtual Account.",
    "NEO+ 步骤3": "Enter the Virtual Account number.",
    "NEO+ 步骤4": "Check details & amount, enter your PIN.",
    "NEO+ 步骤5": "Transaction complete.",
    "ATM BNI": "ATM BNI",
    "ATM BNI 步骤1": "Insert your BNI ATM card & PIN.",
    "ATM BNI 步骤2": "Select Other Menu → Transfer → Savings Account.",
    "ATM BNI 步骤3": "Select To BNI Account.",
    "ATM BNI 步骤4": "Enter the Virtual Account number (16 digits).",
    "ATM BNI 步骤5": "Confirm name & amount, press Yes.",
    "BNI手机银行": "BNI Mobile Banking",
    "BNI手机银行 步骤1": "Login to BNI Mobile Banking.",
    "BNI手机银行 步骤2": "Select Transfer → Virtual Account Billing.",
    "BNI手机银行 步骤3": "Enter the Virtual Account number.",
    "BNI手机银行 步骤4": "Select debit account, confirm with OTP.",
    "网银BNI": "Internet Banking BNI",
    "网银BNI 步骤1": "Login to ibank.bni.co.id.",
    "网银BNI 步骤2": "Select Transfer → Virtual Account Billing.",
    "网银BNI 步骤3": "Enter the Virtual Account number.",
    "网银BNI 步骤4": "Confirm with BNI token.",
    "ATM BRI": "ATM BRI",
    "ATM BRI 步骤1": "Insert your BRI ATM card & PIN.",
    "ATM BRI 步骤2": "Select Other Transactions → Payment → Others → BRIVA.",
    "ATM BRI 步骤3": "Enter the BRIVA number (Virtual Account).",
    "ATM BRI 步骤4": "Check name & amount, press Yes.",
    "BRImo": "BRImo",
    "BRImo 步骤1": "Login to BRImo.",
    "BRImo 步骤2": "Select BRIVA.",
    "BRImo 步骤3": "Enter the Virtual Account number.",
    "BRImo 步骤4": "Enter the amount & PIN, then confirm.",
    "网银BRI": "Internet Banking BRI",
    "网银BRI 步骤1": "Login to ib.bri.co.id.",
    "网银BRI 步骤2": "Select Payment → BRIVA.",
    "网银BRI 步骤3": "Enter the Virtual Account number.",
    "网银BRI 步骤4": "Confirm with mToken.",
    "ATM BSI": "ATM BSI",
    "ATM BSI 步骤1": "Insert your BSI ATM card & PIN.",
    "ATM BSI 步骤2": "Select Pay/Buy → Virtual Account.",
    "ATM BSI 步骤3": "Enter the Virtual Account number.",
    "ATM BSI 步骤4": "Confirm the details & amount.",
    "BSI手机银行": "BSI Mobile",
    "BSI手机银行 步骤1": "Login to BSI Mobile.",
    "BSI手机银行 步骤2": "Select Pay → Virtual Account.",
    "BSI手机银行 步骤3": "Enter the Virtual Account number.",
    "BSI手机银行 步骤4": "Confirm with PIN.",
    "三宝垄银行手机银行": "Mobile Banking Sampoerna",
    "三宝垄银行手机银行 步骤1": "Login to the Sampoerna mobile banking app.",
    "三宝垄银行手机银行 步骤2": "Select Payment → Virtual Account.",
    "三宝垄银行手机银行 步骤3": "Enter the Virtual Account number.",
    "三宝垄银行手机银行 步骤4": "Check the details & confirm with PIN.",
    "ATM Mandiri": "ATM Mandiri",
    "ATM Mandiri 步骤1": "Insert your Mandiri ATM card & PIN.",
    "ATM Mandiri 步骤2": "Select Pay/Buy → Others → Multi Payment.",
    "ATM Mandiri 步骤3": "Enter the company code, then the Virtual Account number.",
    "ATM Mandiri 步骤4": "Confirm name & amount, press Correct.",
    "Livin' by Mandiri": "Livin' by Mandiri",
    "Livin Mandiri 步骤1": "Login to Livin' by Mandiri.",
    "Livin Mandiri 步骤2": "Select Payment → Multi Payment.",
    "Livin Mandiri 步骤3": "Enter the company code & VA number.",
    "Livin Mandiri 步骤4": "Confirm with PIN.",
    "网银Mandiri": "Internet Banking Mandiri",
    "网银Mandiri 步骤1": "Login to ibank.bankmandiri.co.id.",
    "网银Mandiri 步骤2": "Select Payment → Multi Payment.",
    "网银Mandiri 步骤3": "Enter the company code & VA number.",
    "网银Mandiri 步骤4": "Confirm with token.",
    "ATM Muamalat": "ATM Muamalat",
    "ATM Muamalat 步骤1": "Insert your Muamalat ATM card & PIN.",
    "ATM Muamalat 步骤2": "Select Payment → Virtual Account.",
    "ATM Muamalat 步骤3": "Enter the Virtual Account number.",
    "ATM Muamalat 步骤4": "Confirm the amount & press OK.",
    "Muamalat手机银行": "Mobile Banking Muamalat",
    "Muamalat手机银行 步骤1": "Login to DIN by Muamalat.",
    "Muamalat手机银行 步骤2": "Select Payment → Virtual Account.",
    "Muamalat手机银行 步骤3": "Enter the VA number & confirm with PIN.",
    "ATM Permata": "ATM Permata",
    "ATM Permata 步骤1": "Insert your Permata ATM card & PIN.",
    "ATM Permata 步骤2": "Select Other Transactions → Payment → Other Payments → Virtual Account.",
    "ATM Permata 步骤3": "Enter the Virtual Account number.",
    "ATM Permata 步骤4": "Confirm name & amount.",
    "PermataMobile X": "PermataMobile X",
    "PermataMobile X 步骤1": "Login to PermataMobile X.",
    "PermataMobile X 步骤2": "Select Pay Bills → Virtual Account.",
    "PermataMobile X 步骤3": "Enter the VA number.",
    "PermataMobile X 步骤4": "Confirm with PIN.",
    "Alfamart": "Alfamart",
    "Alfamart 步骤1": "Visit the nearest Alfamart store.",
    "Alfamart 步骤2": "Tell the cashier that you want to make a payment via Alfamart.",
    "Alfamart 步骤3": "Show or tell your Payment Code to the cashier.",
    "Alfamart 步骤4": "The cashier will enter the code and display your total bill.",
    "Alfamart 步骤5": "Complete the payment and keep the receipt as proof of payment.",
    "Indomaret": "Indomaret",
    "Indomaret 步骤1": "Visit the nearest Indomaret store.",
    "Indomaret 步骤2": "Tell the cashier that you want to make a bill payment.",
    "Indomaret 步骤3": "Show or tell your Payment Code to the cashier.",
    "Indomaret 步骤4": "The cashier will enter the code and display your total bill.",
    "Indomaret 步骤5": "Complete the payment and keep the receipt as proof of payment.",
    "我们先创建一个账号，这样你就可以开始唱歌并享受所有可用的功能了。": "Let's create an account first so you can start singing and enjoy all the available features.",
    "使用邮箱注册": "Register with Email",
    "我已经拥有一个 Rising 账户": "Already have a RiSing account?",
    "确认密码": "Confirm Password",
    "开始发送代码": "Start Sending Code",
    "电话验证": "Phone Verification",
    "在本文中": "In this Article",
    "订阅自动续费说明": "The RiSing package will be automatically renewed at {price} every {days} days and will be charged to your credit card until canceled. You can cancel anytime via your account settings.",
    "运费保险说明": "Shipping insurance: {price} for {total} items",
    "地址列表": "Address List",
    "请填写送货目的地的地址/城市/区名称": "Write the name of the address / city / sub-district of the delivery destination",
    "添加新地址": "Add New Address",
    "主要的": "Main",
    "更改地址": "Change Address",
    "将其设为主要地址": "Make it the Primary Address",
    "更改此地址": "Change This Address?",
    "没有找到地址": "No address found",
    "选择地点": "Select Place",
    "添加送货地址": "Add Shipping Address",
    "姓名": "Name",
    "收货地址第 1 行": "Shipping Address Line 1",
    "其他详情（例如：楼栋/单元编号、基准值）": "Other Details (e.g. Block/Unit No. Benchmark)",
    "地址另存为": "Save Address as",
    "地址标签": "Address Labels",
    "例如：家庭、办公室或您需要的任何特定标签。": "Example: Home, Office, or any specific label you need.",
    "更改送货地址": "Change Shipping Address",
    "更新": "Update",
    "删除促销？": "Delete Voucher?",
    "您确定要删除此促销活动吗？如果您想再次添加，则需要手动重新输入代码。": "Are you sure you want to delete this promotion? You'll need to re-enter the code manually or select it from the voucher list if you want to add it again.",
    "是的，删除": "Yes, delete",
    "选择": "Choose",
    "尚未保存任何收货地址": "There are no Shipping Addresses saved yet",
    "快来添加您的收货地址，这样您在 Rising 购物时会更方便。": "Come on, add your shipping address to make it easier when shopping at Rising",
    "添加地址": "Add Address",
    "请填写邮箱地址": "Please fill in the email",
    "请填写手机号码": "Please fill in the cell phone number",
    "输入身份证号码": "Enter the ID number",
    "请填写身份证号码": "Please fill in the ID number",
    "出生月份": "Month of Birth",
    "出生年份": "Year of Birth",
    "NPWP 数量": "NPWP Number",
    "添加新信用卡": "Add New Credit Card",
    "地址不可用": "Address not available",
    "合同信息": "Contract Information",
    "只能上传 JPG/PNG/SVG 格式的图片!": "Only JPG, PNG, and SVG formats are allowed!",
    "上传图片大小不能超过 2MB!": "Image size cannot exceed 2MB!",
    "验证码提示": "Enter the 6-digit code sent to you at +62{prefix}-xxxx-{suffix}",
    "请输入您的手机号码，无需输入前导零。": "Enter a phone number starting with 08, 628, or +628 (e.g., +628123456789).",
    "手机号码不匹配": "The phone number does not meet the required format.",
    "更新地址": "Update Address",
    "确认设为主要地址": "Are you sure you want to use this address as your primary address?",
    "从购物车中移除商品": "Remove Product from Cart?",
    "确认从购物车中删除商品": "Are you sure you want to remove this product from the cart?",
    "返回主页": "Back to Home Page",
    "页面未找到": "Page Not Found",
    "请仔细检查网址，或返回主页。": "Please check the URL or return to the home page.",
    "WhatsApp标题": "Start a Conversation",
    "WhatsApp描述": "Hi! Click one of our member below to chat on <strong>Whatsapp</strong>",
    "WhatsApp回复时间": "The team typically replies in a few minutes.",
    "WhatsApp客服": "Customer Service",
    "WhatsApp招聘": "Recruitment Center",
    "设备已激活": "DEVICE SUCCESSFULLY ACTIVATED",
    "设备激活描述": "Your RiSing device has been successfully activated and is ready to use.",
    "检查设备状态": "Check device status",
    "PERANGKAT MAC ADDRESS": "MAC ADDRESS DEVICE",
    "Semua perangkat terhubung ke akun": "All devices are connected to the account",
    "Aktif": "Active",
    "Kedaluwarsa": "Expired",
    "Aktif sampai": "Active until",
    "Berakhir pada": "Expired on",
    "Perbarui Langganan": "Renew Subscription",
    "Tambah Langganan": "Extend Subscription",
    "Ubah Langganan": "Edit Subscription",
    "EMAIL VERIFIKASI TELAH DIKIRIM": "VERIFICATION EMAIL SENT",
    "Kami telah mengirim email verifikasi berisi tautan ke": "We have sent a verification email containing a link to",
    "Tautan tersebut akan kedaluwarsa dalam 24 jam. Jika Anda tidak menemukannya di kotak masuk, silakan periksa folder Sampah /Spam.": "The link will expire in 24 hours. If you do not find it in your inbox, please check your Junk/Spam folder.",
    "Jika masih belum menerima email verifikasi, klik tombol Kirim Ulang di bawah ini.": "If you still haven't received the verification email, click the Resend button below.",
    "Akses hari": "Access {days} days",
    "歌曲请求2": "Request a Song",
    "歌曲请求": "REQUEST A SONG",
    "还没找到你要的歌曲吗？": "Haven't found the song you're looking for?",
    "提交歌曲详情，我们将帮助添加到目录中。": "Submit the song details and we'll help add it to the catalog.",
    "歌曲": "SONG",
    "删除歌曲": "Remove song",
    "歌曲名称": "Song Title",
    "请输入歌曲名称": "Enter song title",
    "歌手姓名": "Artist Name",
    "请输入歌手姓名": "Enter artist name",
    "参考链接（可选）": "Reference Link (Optional)",
    "添加参考链接": "Add a reference link",
    "补充说明（可选）": "Additional Notes (Optional)",
    "添加说明": "Add notes",
    "添加歌曲": "Add Song",
    "联系方式（可选）": "CONTACT INFORMATION (OPTIONAL)",
    "如果您希望在歌曲成功添加后收到通知，请填写以下信息。": "Fill in the details below if you'd like us to contact you once your requested song has been added.",
    "请输入您的姓名": "Enter your name",
    "邮箱/电话号码": "Email/Phone Number",
    "请输入邮箱或电话号码": "Enter email or phone number",
    "发送中...": "Sending...",
    "提交歌曲": "Submit Song",
    "歌曲请求发送成功": "SONG REQUEST SUBMITTED SUCCESSFULLY",
    "我们已收到您的歌曲请求，我们的团队将先进行审核。": "We've received your song request. Our team will review it first.",
    "请期待您选择的歌曲很快出现在您的VOD中。谢谢！": "Look forward to your chosen song appearing in your VOD soon. Thank you!",
    "前往商店": "Go to Store",
    "再次提交歌曲": "Request Another Song",
    "常见问题": "Frequently Asked Questions",
    "我们整理了常见问题，帮助您更轻松地了解和使用RiSing。": "We've compiled frequently asked questions to help you understand and use RiSing more easily.",
    "没有找到您的问题？": "Couldn't find your question?",
    "新手包套装说明1": "RiSing STARTER PACK RTX3M206 SPH (FOR HOME, PERSONAL, NON-COMMERCIAL USE)",
    "新手包简介1": "Turn your TV and home sound system into a karaoke setup",
    "新手包功能1_1": "Ready-to-use karaoke Set-Top Box",
    "新手包功能1_2": "Access to 80,000+ karaoke songs for 1 year",
    "新手包功能1_3": "Ideal for those who already own a karaoke audio system, home cinema setup, or active speakers.",
    "新手包功能1_4": "Ad-free, uninterrupted karaoke",
    "新手包备注1": "Subscription fee of Rp150,000 per month starting the following month",
    "新手包套装说明2": "RiSing KARAOKE CONSOLE ONE RS4P216 SPH (FOR HOME, PERSONAL, NON-COMMERCIAL USE)",
    "新手包简介2": "All-in-one karaoke solution, just switch on and sing",
    "新手包功能2_1": "Complete karaoke package with speaker, karaoke system, and wireless mic",
    "新手包功能2_2": "Access to 80,000+ karaoke songs for 365 days",
    "新手包功能2_3": "Ideal for those of you who only have a TV and need an all-in-one karaoke setup",
    "新手包功能2_4": "Easy and practical installation",
    "新手包备注2": "Subscription fee of Rp 900.000 per year starting the following year",
    "新手包cta": "Start Karaoke Now",
    "FAQ问题1": "<strong>What is RiSing?</strong>",
    "FAQ答案1": "RiSing is a home entertainment karaoke service that provides entertainment systems and karaoke equipment to enhance moments shared with family and friends, designed specifically for personal (non-commercial) use.",
    "FAQ问题2": "<strong>What karaoke products does RiSing offer?</strong>",
    "FAQ答案2": "<strong>RiSing offers two main products:</strong>\n• <strong>Set-Top Box (STB)</strong> – A device that turns your existing TV and speakers into a home karaoke system.\n• <strong>Console One</strong> – A speaker and karaoke system combined in a single device, complete with two wireless microphones. It offers a convenient karaoke experience, as it is ready to use right away.",
    "FAQ问题3": "Are the Set-Top Box and Console One a one-time purchase?",
    "FAQ答案3": "Yes. The Set-Top Box (STB) and Console One can be purchased outright with a single upfront payment, after which the device becomes the customer's full property. \n\nEach purchase includes access to karaoke songs based on the selected package. Once the access period expires, customers can renew their subscription for Rp150,000 (30 days) or Rp900,000 (12 months).",
    "FAQ问题4": "How long is the access period for the karaoke songs?​",
    "FAQ答案4": "• The RiSing Starter Pack (STB) comes with an access period of 3 or 12 months, depending on the selected package.\n• The RiSing Karaoke Console One comes with a 12-month access period.\n\nOnce the access period expires, access to karaoke songs can be extended for a fee of Rp150,000 for 30 days or Rp900,000 for 12 months.\n\nYou only need to purchase access when you wish to use the karaoke service again. RiSing does not use an automatic billing system.",
    "FAQ问题5": "Are there annual or weekly subscription plans?​",
    "FAQ答案5": "Currently, RiSing only offers a 1-month karaoke access package (IDR 150,000) and a 12-month/1-year karaoke access package (IDR 900,000).​",
    "FAQ问题6": "Is this an automatically renewing monthly subscription?​",
    "FAQ答案6": "No. RiSing karaoke access is on-demand, not an auto-renewing subscription (except when paying with a credit card, where your payment provider may support recurring billing). When your access expires, it simply ends. You are under no obligation to make another payment and can purchase access again whenever you’d like.",
    "FAQ问题7": "How does installation work for customers outside Surabaya?​",
    "FAQ答案7": "Both the Set-Top Box and Console One are designed for easy self-installation. If you require assistance, the RiSing team can provide online installation guidance or arrange a technician visit to areas within our service coverage.",
    "FAQ问题8": "Are the songs in RiSing updated regularly?​",
    "FAQ答案8": "Yes. The RiSing song catalog is updated regularly every month. If the song you are looking for is not yet available, users can also submit a request through the <a href=\"/request-song\"><strong>Request a Song</strong></a> page.\n New songs will be processed within approximately one month, depending on the production process​",
    "收银员用户下载": "Cashier App Download",
    "谷歌浏览器下载": "Google Chrome Download",
    "阳光官网": "Sunshine Official Website",
    "24小时客服热线": "24-Hour Customer Hotline",
    "账户类型": "Account Type",
    "选择账户类型": "Select Account Type",
    "电子邮件/电话": "Email/Phone Number",
    "电子邮件/电话占位符": "Enter Email/Phone Number",
    "填写表格": "Fill form first",
    "年度的": "Annual",
    "验证码已发送": "OTP CODE SENT",

    "设定订购数量": "Set Order Quantity",
    "购买小计": "Purchase Subtotal",
    "直接购买": "Buy Now",
    "篮子": "Cart",
    "下载安装指南": "Download Installation Guide",
    "选择订阅时长": "Select Your Subscription Duration",
    "订购数量": "Order Quantity",
    "正在加载...": "Loading...",
    "我知悉，我提供的电子邮箱地址或手机号码将用作我的 RiSing 账户。": "I understand that the email address or mobile number I provide will be used as my RiSing account.",
    "请确认您知悉您的电子邮箱或手机号码将用作您的 RiSIng 账户。": "Confirm that you understand your email or mobile number will be used as your RiSIng account.",
    "联系方式（可选）": "Contact (Optional)",
    "邮箱格式不正确": "Invalid email format.",
    "结账失败；发生错误。": "Checkout failed; an error occurred.",
    "我们已收到您的付款。您可以随时登录账户查看状态并管理订单。": "We have received your payment. Log in to your account to view the status and manage your order at any time.",
    "交易成功": "Transaction successful",
    "登录您的账户": "Log in to your account",
    "尽享各项不断升级的功能": "Explore All RiSing Features",
    "付款已成功收到。请在订单页面查看订单详情及状态。": "Payment received successfully. Please check the order details and status on the order page.",
    "下载发票": "Download Invoice",
    "扫描二维码": "Scan QRIS",
    "下载 QRIS": "Download QRIS",
    "付款方式": "Payment Method",
    "订阅有效期": "Subscription Validity Period",
    "更改服务地点": "Change Service Location",
    "信用卡支付": "Credit Card Payment",
    "Mulai dari": "Start From",
    "Berakhir Sampai": "Ends On",
    "您好，欢迎光临！": "Hello, welcome!​",
    "登录/注册": "Login/Register",
    "开始在家唱卡拉OK": "to start doing karaoke at home",
    "……的一部分": "Part of",
    "由……支持": "Supported by",
    "官方音乐许可": "Official Music License",
    "新手包标签_畅销": "Best Seller",

    "kata_sandi": "Password",
    "ubah_kata_sandi": "Change Password",
    "ubah_kata_sandi_desc": "If there is any activity that does not come from you, please update your account password immediately.",
    "belum_ada_metode": "You don't have a payment method saved yet",
    "belum_ada_metode_desc": "Come, add your payment method to make shopping at Rising easier",
    "kirim_tautan_pre_1": "We will send a password reset link to ",
    "kirim_tautan_pre_2": ". Please press the submit button below, then verify your email to proceed and create a new password.",
    "kirim_tautan_1": "We have sent a link to reset the password to ",
    "kirim_tautan_2": ". Please open the email, then click the Email Verification button to continue the process and create a new password.",
    "verifikasi_email_anda": "Verify your email",
    "kirim_tautan": "Send Link",
    "kirim_ulang_tautan": "Resend Link",
    "batalkan": "Cancel",
    
    "前往计费页面": "Go to Order",
    "MASUKKAN KODE VOUCHER ANDA": "ENTER YOUR VOUCHER CODE",
    "Perangkat ini terdaftar atas nama reseller.": "This device is registered under a reseller's name.",
    "Masukkan kode voucher unik yang terdapat pada Kartu Selamat Datang di dalam kotak perangkat Anda untuk melanjutkan.": "Enter the unique voucher code found on the Welcome Card inside your device box to continue.",
    "Voucher Code": "Voucher Code",
    "Kode voucher tercetak pada kartu yang terdapat di dalam kotak RiSing Anda.": "The voucher code is printed on the card found inside your RiSing box.",
    "Verifikasi Voucher": "Verify Voucher",
    "KODE VOUCHER TELAH KEDALUWARSA": "VOUCHER CODE HAS EXPIRED",
    "Kode voucher ini telah kedaluwarsa. Voucher berlaku selama 1 tahun sejak tanggal pembelian. Jika perangkat Anda belum diaktifkan dalam jangka waktu tersebut, silakan hubungi Customer Support kami untuk mendapatkan kode voucher baru.": "This voucher code has expired. The voucher is valid for 1 year from the date of purchase. If your device has not been activated within this period, please contact our Customer Support to get a new voucher code.",
    "Hubungi Dukungan Pelanggan": "Contact Customer Support",
    "Jam operasional: Senin-Sabtu, 09.00-18.00 WIB. (untuk layanan/bisnis)": "Operational hours: Monday-Saturday, 09.00-18.00 WIB. (for service/business)",
    "WhatsApp CS": "WhatsApp CS",
    "Atau": "Or",
    "Coba dengan kode voucher lain": "Try another voucher code",
    "choose_service_package": "Choose Service Package",
    "start_karaoke_now": "Start Karaoke Now",
    "product_not_found": "Product Not Found",
    "stb_title": "CHOOSE YOUR KARAOKE ACCESS PACKAGE!",
    "stb_feat_1": "Ready to use Karaoke Set-Top Box",
    "stb_feat_2": "Access to 80,000+ karaoke songs for 3 or 12 months",
    "stb_feat_3": "Ad-free, uninterrupted karaoke",
    "console_title": "READY TO START KARAOKE FROM HOME?",
    "console_feat_1": "Complete karaoke package with speaker, karaoke system, and wireless mic",
    "console_feat_2": "Access to 80,000+ karaoke songs for 1 Year",
    "console_feat_3": "Ideal for those who only have a TV and need an all-in-one karaoke setup",
    "console_feat_4": "Easy and practical installation",
    "stb_top_title": "RiSing Karaoke Set-Top Box",
    "stb_big_title": "TURN YOUR REGULAR TV INTO KARAOKE",
    "stb_subtitle": "For maximum fun at home",
    "get_it_here": "Get It Here",
    "stb_banner_title": "SING ALL YOU WANT,\nNOW AT HOME!",
    "stb_banner_desc": "RiSing Karaoke STB offers a <strong>more practical home karaoke experience.</strong> Just <strong>connect to your TV</strong>, speaker, and Wi-Fi, then enjoy access to <strong>tens of thousands of karaoke songs across various genres anytime.</strong>",
    "stb_banner_subdesc": "This product is suitable for those who already have a speaker, sound system, or home theater at home.",
    "common_feat1_title": "HAPPY PUPPY KARAOKE EXPERIENCE,\nRIGHT AT HOME",
    "common_feat1_desc": "Bring your favorite karaoke experience home with minus one, pitch up/down, running text, and song queue features. Just choose a song, set it as you like, and start singing!",
    "stb_feat2_title": "PRACTICAL DESIGN,\nEASY TO CARRY ANYWHERE",
    "stb_feat2_desc": "A practical karaoke device with a minimalist design, compact size, and light weight.",
    "stb_feat2_subdesc": "Easy to store and carry when you want to karaoke at home, gather with family, or have fun with friends.",
    "common_feat3_title": "EASY CONTROL\nWITH SMARTPHONE",
    "common_feat3_desc": "Just scan the QR code on the screen, then control and access all your karaoke needs directly through your smartphone.",
    "common_preview_title": "JUST PLUG, AND SING!",
    "console_top_title": "RiSing Karaoke Console One",
    "console_big_title": "ALL-IN-ONE KARAOKE SPEAKER",
    "console_subtitle": "For maximum karaoke experience",
    "console_banner_title": "POWERFUL SOUND,\nMAXIMUM KARAOKE",
    "console_banner_desc": "RiSing Karaoke Console One delivers more powerful and clear audio with a <strong>woofer, tweeter, and full-range speaker.</strong>",
    "console_banner_subdesc": "Enjoy clearer vocals, more detailed music, and a more exciting and lively karaoke experience at home.",
    "console_feat2_title": "2X WIRELESS MICROPHONES",
    "console_feat2_desc": "Clear Vocals Free from Feedback",
    "spec_impedance": "Nominal\nImpedance",
    "spec_freq_response": "Bass Frequency\nResponse",
    "spec_peak_power": "Peak Power",
    "spec_mic_title": "Wireless UHF Microphone",
    "spec_mic_desc": "Stable mic connection",
    "spec_range_title": "25M Wireless Range",
    "spec_range_desc": "Up to 25 meters range",
    "spec_battery_title": "5H Battery Life",
    "spec_battery_desc": "Up to 5 hours battery life"
}
